var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container praticas-sustentaveis" },
    [
      _vm.modalVisualizarCadastro
        ? _c("AppModalVisualizarCadastro", {
            attrs: { protocolo: _vm.protocolo },
            on: { closeModal: _vm.closeModalVisualizarCadastro }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalVisualizarParceriaIsOpen
        ? _c("ConfirmacaoParceria", {
            attrs: { protocolo: _vm.protocolo, texto: _vm.textoParceria },
            on: {
              closeModal: _vm.closeModalVisualizarParceria,
              atualizarListagem: _vm.limparPesquisa
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.modalVisualizarDocumentoIsOpen
        ? _c("VisualizarDocumentos", {
            attrs: {
              titulo: _vm.tituloVisualizarDocumento,
              documentos: _vm.documentos
            },
            on: { closeModal: _vm.closeModalVisualizarDocumento }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content-cadastro" },
        [
          _c("TitlePage", {
            attrs: {
              title: "Bem-vindo(a) ao Plano ABC+ PA",
              subTitle:
                "Abaixo estão listados os processos disponíveis para consulta."
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-start mt-3 mb-3" },
            [
              _c("FiltroGenerico", {
                attrs: {
                  placeholder:
                    "Pesquisar por número do processo, nome do proprietário ou CPF/CNPJ proprietário...",
                  widthInput: "98%"
                },
                on: {
                  filtrosPesquisa: _vm.pesquisar,
                  limpar: _vm.limparPesquisa
                },
                scopedSlots: _vm._u([
                  {
                    key: "filtros",
                    fn: function() {
                      return [
                        _c("InputSelect", {
                          attrs: {
                            label: "Municípios:",
                            multiSelect: true,
                            opcoes: _vm.municipios
                          },
                          model: {
                            value: _vm.filtro.municipios,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "municipios", $$v)
                            },
                            expression: "filtro.municipios"
                          }
                        }),
                        _vm._v(" "),
                        _c("InputSelect", {
                          attrs: { label: "Status:", opcoes: _vm.status },
                          model: {
                            value: _vm.filtro.status,
                            callback: function($$v) {
                              _vm.$set(_vm.filtro, "status", $$v)
                            },
                            expression: "filtro.status"
                          }
                        })
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("BaseTable", {
            attrs: {
              title: "Listagem",
              tableData: _vm.processos,
              columns: [
                {
                  key: "statusVinculoIcon",
                  label: "",
                  type: "icon",
                  color: function(row) {
                    return row.statusVinculoIconColor
                  },
                  tooltip: function(row) {
                    return row.statusTooltip
                  },
                  width: 50
                },
                { key: "numeroProcesso", label: "Número do processo" },
                { key: "proprietarioNomeRazaoSocial", label: "Proprietário" },
                { key: "proprietarioCpfCnpj", label: "CPF/CNPJ" },
                { key: "nomeImovel", label: "Nome do imóvel" },
                { key: "municipio", label: "Município" },
                { key: "cadastranteNomeRazaoSocial", label: "Cadastrante" },
                { key: "statusFormatado", label: "Status do Processo" },
                { key: "actions", label: "Ações" }
              ],
              pagination: {
                show: true,
                pageSize: _vm.filtro.tamanhoPagina,
                totalPages: _vm.totalPages,
                totalElements: _vm.totalElements
              }
            },
            on: { pageChange: _vm.changePage }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02b2191f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b2191f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App/(authenticated)/modulos/cadastro/listagem-finalizados/listagem-finalizados.vue
// module id = null
// module chunks = 